// SETTINGS REDUCER ACTIONS
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_LOADING = 'SET_LOADING';